import { Contributor, Event } from '@planone/bau365/util-fair-data';
import { CursorPaginatedResponse } from '@planone/shared/util-api-cursor-handling';

import { staticEvents } from './data-access-event.static.mocks';
import { staticExhibitors } from './data-access-exhibitor.static.mocks';
import { describedImageMock, videoMock } from './generic.mocks';

export const contributorMock: Contributor = {
  id: '1',
  title: '',
  first_name: 'Ihr',
  name: 'Ansprechpartner',
  job_title: 'Kundenbetreuung',
  email: 'irgendwas@plan.one',
  phone: '08773 18-78889256',
  mobile: '',
  avatar: {
    description: '',
    resource: 'assets/mock-exhibitor-page/contactPersonIMG.webp',
    provider: 'RAW',
  },
  contributor_role: 'Referent',
  sort_order: 1,
};

export const eventMock: Event = {
  id: '1',
  fair_id: '48',
  exhibitor_id: '1',
  language: 'DE',
  headline: 'Event der BAU 2023',
  starts_at: '2014-04-07T11:59:10.104Z',
  ends_at: '2014-04-07T13:58:10.104Z',
  description: 'Event der BAU 2023',
};

export class EventMockGenerator {
  static elements = 30;
  static mockData = {
    ...eventMock,
  };

  static getIds(exhibitor_id: string | undefined = undefined) {
    if (exhibitor_id && Object.keys(staticExhibitors).includes(exhibitor_id)) {
      return Object.values(staticEvents)
        .filter((product: Event) => product.exhibitor_id === exhibitor_id)
        .map((product: Event) => <string>(<unknown>product.id));
    }

    return [...Array(EventMockGenerator.elements).keys()].map((value) => <string>(<unknown>value));
  }

  static getList(ids: string[] | undefined = undefined, exhibitor_id: string | undefined = undefined) {
    return EventMockGenerator.getIds(exhibitor_id)
      .filter((id: string) => (ids ? ids.includes(<string>(<unknown>id)) : true))
      .map((id: string) => EventMockGenerator.getObject(<string>(<unknown>id), exhibitor_id));
  }

  static getPaginatedList(exhibitor_id: string | undefined = undefined) {
    return <CursorPaginatedResponse<Event>>{
      cursors: {
        next: undefined,
        prev: undefined,
      },
      items: EventMockGenerator.getList(undefined, exhibitor_id),
    };
  }

  static getObject(id: string, exhibitor_id: string | undefined) {
    if (staticEvents[id]) {
      return staticEvents[id];
    }

    return <Event>{
      ...EventMockGenerator.mockData,
      id: <string>(<unknown>id),
      exhibitor_id: exhibitor_id ? exhibitor_id : '0',
      headline: EventMockGenerator.mockData.headline + ' ' + <string>(<unknown>id),
      videos: [videoMock, videoMock, videoMock, videoMock, videoMock, videoMock, videoMock],
      hero_image: describedImageMock(),
    };
  }
}
